var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAgoalIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.00028 13.9767C10.8533 13.9767 13.9769 10.8479 13.9769 6.98833C13.9769 3.12878 10.8533 0 7.00028 0C3.14721 0 0.0236816 3.12878 0.0236816 6.98833C0.0236816 10.8479 3.14721 13.9767 7.00028 13.9767Z",
    fill: "#FF3322"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.62748 6.18831L6.83556 4.56476L6.81208 2.18825L4.53352 1.4353L2.32544 3.03532L2.34893 5.43536L4.62748 6.18831Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.58055 6.40023L2.30199 5.69434L0.892578 7.62377L1.73823 10.2356L4.01678 10.9415L5.44969 9.01202L4.58055 6.40023Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.63763 9.12948L4.25171 11.0825L5.63763 13.0119H8.38599L9.77191 11.0589L8.38599 9.10596L5.63763 9.12948Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6511 5.62354L9.37251 6.32943L8.52686 8.96476L9.95976 10.8707L12.2383 10.1648L13.084 7.52944L11.6511 5.62354Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5338 5.38824L11.5572 2.98821L9.32567 1.38818L7.07061 2.14113L7.04712 4.54117L9.27869 6.14119L11.5338 5.38824Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5336 2.75288L12.8021 3.05877C11.8625 1.67051 10.4296 0.635205 8.73828 0.21167L9.32554 1.17639L11.5336 2.75288Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M4.29857 1.31753L4.93281 0.282227C3.35896 0.776351 2.04351 1.81166 1.15088 3.15285L2.11398 2.91756L4.29857 1.31753Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M0.704707 7.78838L0 6.96484C0 8.58839 0.540273 10.0943 1.47988 11.2708L1.55035 10.3531L0.704707 7.78838Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M5.73152 13.2003L4.72144 13.6238C5.42614 13.8591 6.20132 14.0003 6.99999 14.0003C7.84564 14.0003 8.64431 13.8591 9.3725 13.5768L8.43289 13.1768L5.73152 13.2003Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M12.426 10.0943L12.52 11.3178C13.4596 10.1178 13.9999 8.63543 13.9999 7.01188C13.9999 6.89423 13.9999 6.77658 13.9999 6.65894L13.2482 7.52954L12.426 10.0943Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgoalIcon);
export default __webpack_public_path__ + "static/media/agoal_icon.7a7d932f56c9fb3bfcabe174773e45b5.svg";
export { ForwardRef as ReactComponent };